import { ApiError } from './client.js';
/**
 * Sign-in failures, in Bahasa Indonesia.
 *
 * The API answers in English (`invalid credentials`), which is right for a log
 * line and wrong for the one screen every user meets before they are a user.
 * PWA-01 requires Indonesian strings, so the translation happens here rather
 * than in each application's login page — there are two of them now and they
 * must not disagree about what a 401 means.
 *
 * Deliberately vague on WHICH half was wrong. "No account with that NIK"
 * confirms which employee numbers exist, and this endpoint is unauthenticated
 * (TSP 7.3 enumeration) — a concern that got sharper, not softer, when the
 * identifier became a short sequential number. The server already refuses to
 * distinguish them; so does this.
 */
export function loginErrorMessage(error) {
    if (error instanceof ApiError) {
        if (error.status === 401)
            return 'NIK atau kata sandi salah.';
        if (error.status === 429)
            return 'Terlalu banyak percobaan. Coba lagi sebentar.';
        if (error.status === 400)
            return 'Periksa kembali NIK dan kata sandi.';
        // A 5xx or a network failure is not the user's mistake; say so rather than
        // implying their credentials were the problem.
        if (error.status >= 500)
            return 'Server sedang bermasalah. Coba lagi beberapa saat.';
        return error.message;
    }
    return 'Tidak dapat terhubung ke server. Periksa koneksi Anda.';
}
/** The second factor, which fails for its own reasons. */
export function totpErrorMessage(error) {
    if (error instanceof ApiError) {
        if (error.status === 401)
            return 'Kode autentikasi salah atau sudah kedaluwarsa.';
        if (error.status === 429)
            return 'Terlalu banyak percobaan. Coba lagi sebentar.';
        if (error.status >= 500)
            return 'Server sedang bermasalah. Coba lagi beberapa saat.';
        return error.message;
    }
    return 'Tidak dapat terhubung ke server. Periksa koneksi Anda.';
}
//# sourceMappingURL=auth-errors.js.map